const LedgerLive = () => (
  <svg fill='none' viewBox='0 0 24 25'>
    <path fill='#fff' d='M.001 12.514c0-6.627 5.373-12 12-12s12 5.373 12 12c0 6.628-5.373 12-12 12s-12-5.372-12-12Z' />
    <path
      fill='#000'
      d='M4.001 15.524v3.956h6.018v-.877H4.878v-3.079H4Zm15.123 0v3.08h-5.141v.876H20v-3.956h-.877Zm-9.096-6.02v6.02h3.955v-.79h-3.078v-5.23h-.877ZM4.001 5.548v3.956h.877V6.426h5.141v-.878H4.001Zm9.982 0v.878h5.141v3.078h.877V5.548h-6.018Z'
    />
  </svg>
)

export { LedgerLive }
